import { useAuth } from '../context/AuthContext';
import { Eye, X, Loader2 } from 'lucide-react';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';

export default function ImpersonationBanner() {
  const { user, isImpersonating, stopImpersonate } = useAuth();
  const [exiting, setExiting] = useState(false);
  const navigate = useNavigate();

  if (!isImpersonating()) return null;

  const handleStop = async () => {
    setExiting(true);
    try {
      await stopImpersonate();
      toast.success('Volviste a tu sesion de Super Admin');
      navigate('/super-admin');
    } catch (err) {
      toast.error('Error al volver');
    } finally {
      setExiting(false);
    }
  };

  return (
    <div
      data-testid="impersonation-banner"
      className="fixed top-0 left-0 right-0 z-[100] bg-gradient-to-r from-amber-600 to-red-600 text-white px-3 py-2 shadow-lg flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 text-xs sm:text-sm"
    >
      <div className="flex items-center gap-2">
        <Eye className="w-4 h-4 flex-shrink-0" />
        <span className="font-semibold">Modo soporte:</span>
        <span className="truncate">
          estas viendo como <strong>{user?.email}</strong>
          {user?.impersonated_by_email && <span className="hidden sm:inline opacity-80"> (super admin: {user.impersonated_by_email})</span>}
        </span>
      </div>
      <button
        onClick={handleStop}
        disabled={exiting}
        data-testid="stop-impersonate-btn"
        className="flex items-center gap-1 bg-white/20 hover:bg-white/30 px-3 py-1 rounded-full font-semibold transition-colors disabled:opacity-50"
      >
        {exiting ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <X className="w-3.5 h-3.5" />}
        Volver a Super Admin
      </button>
    </div>
  );
}
